export default __webpack_public_path__ + "static/media/GAZIR.5918b25e.png";